import {
  ARRIVO_BIO_MDD_PHASE_2,
  MINDMED_GAD_PHASE_3,
  MINDMED_GAD_PHASE_3_SISTER_TRIAL,
  MINDMED_MDD_PHASE_3,
  NEUROCRINE_MDD_PHASE_3_1,
  NEUROCRINE_MDD_PHASE_3_2,
  NEUROCRINE_MDD_PHASE_3_3,
  NEUROCRINE_MDD_PHASE_3_4,
  OTSUKA_MDD_PHASE_2_AND_3,
  VISTAGEN_PALISADE_3,
  VISTAGEN_PALISADE_4,
} from '../constants/trials'

export const isAnyMindMed = (nctId: string): boolean => {
  return [
    MINDMED_GAD_PHASE_3.nctId,
    MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId,
    MINDMED_MDD_PHASE_3.nctId,
  ].includes(nctId)
}

export const isMindMedGad3 = (nctId: string): boolean => {
  return [
    MINDMED_GAD_PHASE_3.nctId,
    MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId,
  ].includes(nctId)
}

export const isOtsukaMdd = (nctId: string): boolean => {
  return [OTSUKA_MDD_PHASE_2_AND_3.nctId].includes(nctId)
}

export const isVistagenPalisade = (nctId: string): boolean => {
  return [VISTAGEN_PALISADE_3.nctId, VISTAGEN_PALISADE_4.nctId].includes(nctId)
}

export const isNeurocrineMdd = (nctId: string): boolean => {
  return [
    NEUROCRINE_MDD_PHASE_3_1.nctId,
    NEUROCRINE_MDD_PHASE_3_2.nctId,
    NEUROCRINE_MDD_PHASE_3_3.nctId,
    NEUROCRINE_MDD_PHASE_3_4.nctId,
  ].includes(nctId)
}

export const isArrivoBioMdd = (nctId: string): boolean => {
  return [ARRIVO_BIO_MDD_PHASE_2.nctId].includes(nctId)
}
